import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { breakpoints } from '../helpers/breakpoints';

const StyledButton = styled(Link)`
  display: inline-block;
  background: var(--c-light-green);
  color: var(--c-white);
  text-decoration: none;
  font-weight: 700;
  text-align: center;
  padding: 1.5rem 2rem;
  border-radius: var(--border-radius);
  font-size: 1.6rem;
  transition: all 0.3s ease;
  @media screen and (min-width: ${breakpoints.md}) {
    padding: 2rem 4rem;
    border-radius: var(--border-radius);
    font-size: 2rem;
  }
  @media (hover: hover) {
    &:hover {
      transform: scale(1.05);
      background: #26ae9a;
    }
  }
`;
const Button = props => {
  const { as, to, text, className } = props;
  return (
    <StyledButton as={as} className={className} to={to}>
      {text}
    </StyledButton>
  );
};

Button.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
};

export default Button;
